// extracted by mini-css-extract-plugin
export default {"tableHead":"muitable_tableHead__2bji5","tableHeadCell":"muitable_tableHeadCell__FKAR7","tablebody":"muitable_tablebody__CsRoH"};